import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeCreateGuarantorConfig = () => ({
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'guarantors',
  ],
});

const requestOptions = makeCreateGuarantorConfig();

export const consts = createReqConsts('create-guarantor');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/requests/create-guarantor-req.js